<div class="naplo-wrap">
  <div class="n-fulek">
    <button type="button" [class.aktiv]="nezet === 'globalis'" (click)="nezet = 'globalis'">
      <ion-icon name="globe-outline"></ion-icon> Globális (minden ügyfél)
    </button>
    <button type="button" [class.aktiv]="nezet === 'ugyfel'" (click)="nezet = 'ugyfel'">
      <ion-icon name="person-outline"></ion-icon> {{ aktiv.ugyfelNev || 'Kiválasztott ügyfél' }}
    </button>
  </div>

  <!-- ══════════ GLOBÁLIS (INTÉZMÉNYI) ══════════ -->
  <ng-container *ngIf="nezet === 'globalis'">
    <ion-card class="naplo-card">
      <ion-card-header>
        <ion-card-title style="font-size:1.05rem;color:var(--naplo)"><ion-icon name="globe-outline"></ion-icon> Szinkron-időzítés minden ügyfélre</ion-card-title>
        <ion-card-subtitle>
          Amit itt bekapcsolsz, az MINDEN ügyfélnél érvényes – nem kell egyesével végigmenni rajtuk.
          Ha egy ügyfélnél külön be van állítva, az felülírja ezt (a „felülírt” oszlopban látszik, és egy kattintással visszaadható).
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="tabla-wrap">
          <table class="naplo-tabla">
            <thead><tr>
              <th>Forrás</th><th class="kozep">Bekapcsolva</th><th>Intervallum (perc)</th>
              <th class="kozep">Érintett ügyfél</th><th class="kozep">Felülírva</th><th>Hiányzó hitelesítő</th>
            </tr></thead>
            <tbody>
              <tr *ngFor="let g of globalis">
                <td><ion-icon [name]="forrasIkon[g.forras]" color="primary"></ion-icon> {{ forrasCimke[g.forras] || g.forras }}</td>
                <td class="kozep"><ion-toggle [(ngModel)]="g.enabled" [ngModelOptions]="{standalone:true}" (ionChange)="globalisMent(g)"></ion-toggle></td>
                <td><ion-input class="szuk" type="number" fill="outline" [(ngModel)]="g.intervallum_perc" [ngModelOptions]="{standalone:true}" min="5" max="1440" (ionBlur)="globalisMent(g)"></ion-input></td>
                <td class="kozep">{{ g.bekapcsolva_db }} / {{ g.ugyfel_db }}</td>
                <td class="kozep">
                  <span *ngIf="!g.felulirt_db" class="halvany">—</span>
                  <button *ngIf="g.felulirt_db" type="button" class="ov-gomb" (click)="globalisra(g)" title="Az ügyfél-szintű beállítások törlése – mindenki a globálisat követi">
                    {{ g.felulirt_db }} db · vissza a globálisra
                  </button>
                </td>
                <td>
                  <span *ngIf="!g.hianyzo_db" class="halvany">—</span>
                  <ion-badge *ngIf="g.hianyzo_db" color="warning" (click)="szuroForras = g.forras; csakProblemas = true" style="cursor:pointer"
                             title="Ennyi ügyfélnél be van kapcsolva, de nincs meg a hitelesítő – ott a lekérés el sem indul">{{ g.hianyzo_db }} ügyfél</ion-badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="halvany" style="font-size:.82rem;margin:10px 2px 0">
          Ahol nincs meg a forráshoz szükséges hitelesítő (NAV technikai felhasználó, M2M-kapcsolat, hozzárendelt
          Ügyfélkapu-fiók, élő banki meghatalmazás), ott a rendszer <b>meg sem próbálja</b> a lekérést – „kihagyva” eredménnyel jelzi.
        </p>
      </ion-card-content>
    </ion-card>

    <!-- Áttekintés: ügyfél × forrás -->
    <ion-card class="naplo-card">
      <ion-card-header>
        <ion-card-title style="font-size:1rem;color:var(--naplo)"><ion-icon name="list-outline"></ion-icon> Ügyfelenkénti állapot</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <div class="n-szuro-sor">
          <label>Forrás
            <select [(ngModel)]="szuroForras" [ngModelOptions]="{standalone:true}">
              <option value="">mind</option>
              <option *ngFor="let g of globalis" [value]="g.forras">{{ forrasCimke[g.forras] || g.forras }}</option>
            </select>
          </label>
          <label style="display:inline-flex;align-items:center;gap:6px">
            <input type="checkbox" [(ngModel)]="csakProblemas" [ngModelOptions]="{standalone:true}"> csak ahol hiányzik a hitelesítő
          </label>
          <span class="spacer" style="flex:1"></span>
          <button type="button" class="ov-gomb" (click)="globalisBetolt()"><ion-icon name="refresh-outline"></ion-icon>Frissítés</button>
        </div>
        <div class="tabla-wrap">
          <table class="naplo-tabla">
            <thead><tr><th>Ügyfél</th><th>Forrás</th><th class="kozep">Állapot</th><th>Utolsó futás</th><th>Eredmény</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let s of szurtAttekintes">
                <td>{{ s.ugyfel_nev }}</td>
                <td>{{ forrasCimke[s.forras] || s.forras }}</td>
                <td class="kozep">
                  <ion-badge [color]="s.enabled ? 'success' : 'medium'">{{ s.enabled ? 'be' : 'ki' }}</ion-badge>
                  <ion-badge *ngIf="s.felulirva" color="tertiary" style="margin-left:4px" title="Ügyfél-szintű beállítás – felülírja a globálisat">saját</ion-badge>
                  <ion-badge *ngIf="s.enabled && s.elofeltetel === false" color="warning" style="margin-left:4px" [title]="s.elofeltetel_uzenet">nincs hitelesítő</ion-badge>
                </td>
                <td class="halvany">{{ s.utolso_futas ? (s.utolso_futas | date:'short') : '—' }}</td>
                <td class="halvany">{{ s.elofeltetel === false ? s.elofeltetel_uzenet : (s.utolso_eredmeny || '—') }}</td>
                <td>
                  <button *ngIf="s.felulirva" type="button" class="ov-gomb" (click)="felulirTorol(s)" title="Az ügyfél saját beállításának törlése">globálisra</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="ures" *ngIf="!szurtAttekintes.length">Nincs megjeleníthető sor.</div>
        </div>
      </ion-card-content>
    </ion-card>
  </ng-container>

  <!-- ══════════ EGY ÜGYFÉL ══════════ -->
  <ng-container *ngIf="nezet === 'ugyfel'">
    <div *ngIf="!aktiv.ugyfelId" class="ures">Válassz ügyfelet az Ügyfelek menüben a saját időzítés beállításához.</div>
    <ion-card class="naplo-card" *ngIf="aktiv.ugyfelId">
      <ion-card-header>
        <ion-card-title style="font-size:1.05rem;color:var(--naplo)"><ion-icon name="timer-outline"></ion-icon> {{ aktiv.ugyfelNev }}</ion-card-title>
        <ion-card-subtitle>„Globális szerint” = az intézményi beállítást követi. A „bekapcsolva”/„kikapcsolva” felülírja azt.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="tabla-wrap">
          <table class="naplo-tabla">
            <thead><tr><th>Forrás</th><th>Beállítás</th><th>Intervallum (perc)</th><th>Utolsó futás</th><th>Eredmény</th></tr></thead>
            <tbody>
              <tr *ngFor="let s of szinkron">
                <td><ion-icon [name]="forrasIkon[s.forras]" color="primary"></ion-icon> {{ forrasCimke[s.forras] || s.forras }}</td>
                <td>
                  <select [ngModel]="allapot(s)" [ngModelOptions]="{standalone:true}" (ngModelChange)="allapotValt(s, $event)">
                    <option value="globalis">globális szerint ({{ s.globalis_enabled ? 'be' : 'ki' }})</option>
                    <option value="be">bekapcsolva</option>
                    <option value="ki">kikapcsolva</option>
                  </select>
                </td>
                <td>
                  <ion-input class="szuk" type="number" fill="outline" [(ngModel)]="s.intervallum_perc" [ngModelOptions]="{standalone:true}"
                             min="5" max="1440" [disabled]="s.sajat_enabled == null" (ionBlur)="percMent(s)"></ion-input>
                </td>
                <td class="halvany">{{ s.utolso_futas ? (s.utolso_futas | date:'short') : '—' }}</td>
                <td class="halvany">{{ s.utolso_eredmeny || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-card-content>
    </ion-card>
  </ng-container>
</div>
